import React from "react";
import "./Subheader.css";

function Subheader() {
  return (
    <div className="epic-subheader">
      <div className="sub-inner">

        <div className="sub-left">
          <span>
            <i className="fa-solid fa-location-dot"style={{ fontSize: "26px" }}></i>
           First Settlement ,New Cairo , Egypt
          </span>
          <span>
            <i className="fa-solid fa-phone"style={{ fontSize: "26px" }}></i>
            +2095176686
          </span>
          <span>
            <i className="fa-solid fa-envelope"style={{ fontSize: "26px" }}></i>
            pyramid01008000@gmail.com
          </span>
        </div>

        <div className="sub-right">
          <a href="https://www.facebook.com/share/184sAC6paV/"target="_blank" ><i className="fa-brands fa-facebook-f"style={{ fontSize: "26px",}} ></i></a>
          <a href="https://www.instagram.com/pyramidd_constructions?igsh=eHd4YXpucHphM2V1" target="_blank"><i className="fa-brands fa-instagram"style={{ fontSize: "26px" }}></i></a>
          <a href="https://www.tiktok.com/@pyramid_company1?_r=1&_t=ZS-93QISGBhWD3" target="_blank"><i class="fa-brands fa-tiktok"style={{ fontSize: "26px" }}></i></a>
        </div>

      </div>
    </div>
  );
}

export default Subheader;
